import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function AwardsLists() {
  const [AwardsLists, setAwardsLists] = useState({});

  useEffect(() => {
    const fetchAwardsLists = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/awards/award-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setAwardsLists(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAwardsLists();
  }, []);

  const awardslists = AwardsLists.awards_lists
    ? JSON.parse(AwardsLists.awards_lists)
    : [];

  return (
      <section className="about-amenities-sec awards-list-sec">
        <Container fluid>
          <Row className="flex-center">
            <Col md={9} className="padding-zero">
              <div className="text-center mb-5" data-aos="fade-up">
                <h2 className="common-head greyColor">
                  {AwardsLists.section_title}
                </h2>
                <p className="common-para">
                  {AwardsLists.section_description}​
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row className="flex-center about-amenity-row">
            {awardslists.map((awardslist, index) => (
              <Col md={6} key={index}>
                <div className="about-amenity-card" data-aos="fade-up">
                  <div className="about-amenity-img">
                    {/* <LazyLoad> */}
                      <img
                        src={`${apiUrl.apiUrl}/${awardslist.image}`}
                        className="img-fluid"
                        alt="Amenity"
                      />
                    {/* </LazyLoad> */}
                  </div>
                  <div className="about-amenity-content">
                    <p className="common-para whiteColor">
                      {awardslist.award_description}
                    </p>
                    <h2 className="common-head whiteColor">
                      {awardslist.award_title}
                    </h2>
                  </div>
                  <div className="awards-year-div text-center">
                    <p className="common-para">{awardslist.year}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
  );
}
export default AwardsLists;
